<template>
  <Toaster />
  <component :is="layout">
    <router-view />
  </component>
  <ModalManager />
</template>
<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import { isAuthenticated } from '@/utils/auth';
import ModalManager from '@/components/modals/ModalManager.vue';
import { useAuthStore } from '@/store/auth';
import Toaster from '@/components/ui/toast/Toaster.vue'

const route = useRoute();
console.log("@route.meta.layout", route.meta.layout);
const authStore = useAuthStore();

const layout = computed(() => {
  // const layoutName = route.meta.layout;
const matchedLayout = route.matched.find(r => r.meta.layout)?.meta.layout;

  console.log("@route.meta.layout", route.meta.layout);
  console.log("@matchedLayout", matchedLayout);
  console.log("@authStore.isAuthenticated()", authStore.isAuthenticated());

  if (matchedLayout === 'DefaultLayout' && !authStore.isAuthenticated()) {
    return AuthLayout; 
  }

  return {
    DefaultLayout,
    AuthLayout
  }[matchedLayout] || DefaultLayout;
});

</script>
